<script>
    import { onDestroy } from "svelte";
    import { page, modal } from '../store/nav';
    import { recurring } from "../store/recurring";
    import { idb } from "../db";

    const menu = [
        {
            name: 'Delete all',
            fn: () => {
                modal.close();
            }
        }
    ];

    onDestroy(() => {
        console.group(`INFO: menu-list .onDestroy`);console.groupEnd();
    });
</script>

<section class="flex flex-col space-y-7 m-auto font-semibold text-primary">
    {#each menu as menuEntry}
        <span class="m-auto " on:click|stopPropagation={menuEntry.fn}>{menuEntry.name}</span>
    {/each}
</section>
